import { render } from "./Home.vue?vue&type=template&id=2bed883b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2bed883b&scoped=true&lang=css"
import "./Home.vue?vue&type=style&index=1&id=2bed883b&scoped=true&lang=scss"
import "./Home.vue?vue&type=style&index=2&id=2bed883b&lang=css"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bed883b"]])

export default __exports__